import { useEffect, useState, useRef } from "react";
import { readFromLocalStorage } from "../../utils/DataEncryption";
import HeaderWeb from "./HeaderWeb";
import MobileResponsiveHeader from "./MobileResponsiveHeader";
import HeaderWithoutSideMenu from "./HeaderWithoutSideMenu";
export const componentMap: Record<string, string> = {
  StaffDetail: "Staff Detail",
};
const Header = () => {
  const [logout, setLogout] = useState(false);
  const baseURL = process.env.REACT_APP_LOGOUTURL;
  const appId = readFromLocalStorage("appId") || process.env.REACT_APP_APPID;
  const currentUrl = window.location.href;
  const routeUrl = currentUrl.split("#/");
  const pathParams = routeUrl[1]?.split("/") || [];
  const mainRoute = pathParams[0];

  const handleLogout = async () => {
    const url = `${baseURL}/auth/v1/app/logout?app_id=${appId}&country=IN`;
    window.location.href = url;
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("userType");
    sessionStorage.removeItem("dealerId");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("appId");
    sessionStorage.removeItem("baseRoles");
  };
  const logoutRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        logout &&
        logoutRef.current &&
        !logoutRef.current.contains(event.target as Node)
      ) {
        setLogout(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [logout]);


  return (
    <>
      {/* Mobile + Tablet (0px - 1023px) */}
      <div className="block lg:hidden">
        {routeUrl[1] === "dashboard" || routeUrl[1] === "staffList" ? (
          <MobileResponsiveHeader
            handleLogout={handleLogout}
            setLogout={setLogout}
            isLogout={logout}  
           
          />
        ) : (
          <HeaderWithoutSideMenu pageTitle={componentMap[mainRoute]} />
        )}
      </div>

      {/* Desktop only (1024px and above) */}
      <div className="hidden lg:block">
        <HeaderWeb
          handleLogout={handleLogout}
          setLogout={setLogout}
          isLogout={logout}
        />
      </div>
    </>
  );
};

export default Header;
